/* eslint-disable react/no-unknown-property */
import React from 'react';
import classNames from 'classnames';
import { map } from 'lodash';

import './style.scss';

const MultipleMarquee = (props) => {
    const {
        list = [],
    } = props;

    return (
        <div className='marquee-custom'
        >
            <marquee
                key={list?.length}
                scrollamount="1.5"
                scrolldelay="15"
                truespeed="true"
                width="100%"
            >
                <div
                    className="marquee-custom-child-wrap"
                >
                    {map(list, (item, index) => (
                        <div
                            key={index}
                            className={classNames(
                                'marquee-custom-child'
                            )}
                        >
                            <div dangerouslySetInnerHTML={{ __html: item }}/>
                        </div>
                    ))}
                </div>
            </marquee>
        </div>
    );
};

export default MultipleMarquee;
